export default __webpack_public_path__ + "static/media/dewhurst-logo-white.d64df545.png";